<template>
  <div>
    <InfoDialog
      title="Post a job opportunity and earn 100 €/£!"
      content-class="share-opp-rewards-dialog"
      :show="show"
      :content-style="contentStyle"
      @hide="handleDialogHide"
    >
      <div>
        <ul class="reset-list">
          <li>
            <strong>Step 1:</strong> Post a job opportunity on the
            <router-link to="/opportunities">
              Opportunities
            </router-link>&nbsp;page and earn 100 €/£ once validated by our team.
          </li>
          <li>
            <strong>Step 2:</strong> Your job opportunity will be visible to our network of high-quality consultants on the platform.
          </li>
          <li>
            <strong>Step 3:</strong> We will also send you a curated list of the most relevant candidates for your opportunity from our network.
          </li>
          <li>
            <strong>Step 4:</strong> You will be notified when someone applies to your opportunity and you can directly liaise with candidates to find the perfect fit.
          </li>
        </ul>
        <p class="mt-2">
          <i>*100 euro/pound reward valid until 30th September 2020 for <span class="text-decoration-underline">validated</span> opportunities</i>
        </p>
        <div class="text-center">
          <v-btn
            class="mt-3"
            color="primary"
            rounded
            light
            @click="handlePostOppClick"
          >
            Post a job opportunity
          </v-btn>
        </div>
      </div>
    </InfoDialog>
    <v-dialog
      v-model="showCreateDialog"
      fullscreen
      persistent
      transition="dialog-bottom-transition-10"
    >
      <createOpportunity
        @hide="showCreateDialog = false"
        @submitOpp="submitOpp"
      />
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import InfoDialog from '@/components/core/InfoDialog.vue'
import createOpportunity from '@/components/opportunities/createOpportunity.vue'
import { waitAsync } from '@/utils/common'
import { MODAL_TRANSITION_TIME, PURPLE_BG_GRADIENT } from '@/constants'
import { postJobRewardEvents } from '@/segmentAnalytics/rewards'

@Component({
  components: {
    InfoDialog,
    createOpportunity
  }
})
export default class PostJobCampaignDialog extends Vue {
  @Prop({ required: true }) show: boolean
  contentStyle: string = PURPLE_BG_GRADIENT

  showCreateDialog: boolean = false

  handlePostOppClick () {
    postJobRewardEvents.trackPostJob()
    this.showCreateDialog = true
  }

  handleDialogHide () {
    postJobRewardEvents.trackClose()
    this.$emit('hide')
  }

  async submitOpp (input: any) {
    this.showCreateDialog = false
    await waitAsync(MODAL_TRANSITION_TIME)
    this.$store.dispatch('upsertOpportunity', input)
  }
}
</script>
<style lang='scss'>
.share-opp-rewards-dialog {
  .info-icon {
    background-image: none;
    background-color: #fff;
    color: #8E59FF;
  }
}
</style>
